import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '../components/ui/button';

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optional: Verify payment status with backend
    if (sessionId) {
      console.log('Payment successful! Session ID:', sessionId);
    }
  }, [sessionId]);

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon">
          <div className="check-circle">
            <Check size={64} />
          </div>
        </div>
        
        <h1 className="success-title">Welcome to AthloPeak!</h1>
        <p className="success-message">
          Your subscription is now active. Get ready to transform your fitness journey.
        </p>
        
        <div className="success-details">
          <h3>What's Next?</h3>
          <ul>
            <li>Check your email for your account details</li>
            <li>Download the AthloPeak app from your app store</li>
            <li>Complete your onboarding to get your personalized plan</li>
          </ul>
        </div>

        <div className="success-actions">
          <Button className="btn-cta" onClick={() => window.location.href = '/'}>
            Back to Home
          </Button>
        </div>

        {sessionId && (
          <p className="success-session">Session ID: {sessionId}</p>
        )}
      </div>
    </div>
  );
};

export default Success;
